/* tslint:disable */

/* eslint-disable */

/**
 * API Gateway Backstage Plugin
 * Backstage plugins api spec
 *
 * The version of the OpenAPI document: v1
 * Contact: sarkan.mo@tomtom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * A list of targets to forward traffic to.
 * @export
 * @interface RouteForward
 */
export interface RouteForward {
  /**
   *
   * @type {string}
   * @memberof RouteForward
   */
  target?: string;
  /**
   *
   * @type {string}
   * @memberof RouteForward
   */
  rewritePath?: string;
}

/**
 * Check if a given object implements the RouteForward interface.
 */
// @ts-ignore
export function instanceOfRouteForward(value: object): value is RouteForward {
  return true;
}

export function RouteForwardFromJSON(json: any): RouteForward {
  return RouteForwardFromJSONTyped(json, false);
}

export function RouteForwardFromJSONTyped(
  json: any,
  // @ts-ignore
  ignoreDiscriminator: boolean,
): RouteForward {
  if (json == null) {
    return json;
  }
  return {
    target: json['target'] == null ? undefined : json['target'],
    rewritePath:
      json['rewrite_path'] == null ? undefined : json['rewrite_path'],
  };
}

export function RouteForwardToJSON(json: any): RouteForward {
  return RouteForwardToJSONTyped(json, false);
}

export function RouteForwardToJSONTyped(
  value?: RouteForward | null,
  // @ts-ignore
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    target: value['target'],
    rewrite_path: value['rewritePath'],
  };
}
